import React from "react";
import { SoundboxSettings } from "../types/soundboxSettings";

export const BackgroundSelectionContext = React.createContext<{
  data: SoundboxSettings;
  setData: React.Dispatch<React.SetStateAction<SoundboxSettings>>;
}>({ data: { volume: 50, surroundings: null }, setData: () => null });
